import {TranslatableString} from './TranslatableString';

export class Article {
  header: TranslatableString;
  content: TranslatableString;
}
